// extracted by mini-css-extract-plugin
export default {"touchableComponent":"TouchableComponent_touchableComponent__ff30y"};